export default function TierModel(dict) {
    this.privilegeId = dict.PRIVILEGE_ID || null;
    this.tierEndLastYear = dict.TIER_END_LAST_YEAR || null;
    this.tierEndLastMonth = dict.TIER_END_LAST_MONTH || null;
    this.tierEndLastWeek = dict.TIER_END_LAST_WEEK || null;
    this.vipTierEndLastYear = dict.VIP_TIER_END_LAST_YEAR || null;
    this.vipTierEndLastMonth = dict.VIP_TIER_END_LAST_MONTH || null;
    this.vipTierEndLastWeek = dict.VIP_TIER_END_LAST_WEEK || null;
    this.ambassador = dict.AMBASSADOR || null;
    this.birthMonth = dict.BIRTH_MONTH || null;
    this.ambassadorPeriod = dict.AMBASSADOR_PERIOD || null;
    this.lang = dict.LANG || null;
    this.channel = dict.CHANNEL || null;
}